import { render } from "./FavoriteSuggestList.vue?vue&type=template&id=7dab5eaa&scoped=true"
import script from "./FavoriteSuggestList.vue?vue&type=script&lang=js"
export * from "./FavoriteSuggestList.vue?vue&type=script&lang=js"

import "./FavoriteSuggestList.vue?vue&type=style&index=0&id=7dab5eaa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dab5eaa"]])

export default __exports__